import React from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {action} from 'mobx'
import {observer, inject} from 'mobx-react'


import {Row, Col, Panel, Button, Clearfix, ListGroup, ListGroupItem, Modal} from 'react-bootstrap';
import {BMC_STAGES} from "../common_components/bmc/bmc_constants";

@observer
class Filters extends React.Component {
    constructor(props) {
        super(props);


        this.state = {};
    }

    render() {
        const {rootStore, intl} = this.props;
        return (
            <div>
                <Row>
                    <h3 style={{textAlign: 'center'}}><FormattedMessage id={'filter_by_stage'}/></h3>
                    <hr/>
                    <Col md={6}>
                        <ListGroup>
                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.OBSERVATIONAL)}
                            </ListGroupItem>

                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.FIRST_USER)}
                            </ListGroupItem>

                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.FIRST_GROUP)}
                            </ListGroupItem>

                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.FOCUS_GROUP)}
                            </ListGroupItem>
                        </ListGroup>
                    </Col>

                    <Col md={6}>
                        <ListGroup>
                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.KNOW_HOW)}
                            </ListGroupItem>

                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.EARLY_ADOPTERS)}
                            </ListGroupItem>

                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.FIRST_CLIENT)}
                            </ListGroupItem>

                            <ListGroupItem>
                                {this.renderFilterInput(BMC_STAGES.FREE)}
                            </ListGroupItem>
                        </ListGroup>
                    </Col>

                </Row>
            </div>
        );
    }

    renderFilterInput = (stage) => {

        const {rootStore, intl} = this.props;

        const isCurrentStage = rootStore.currentStage === stage;

        return (
            <label key={`key-${stage}`}>
                <input className='filter-category-input'
                       name={stage}
                       type="checkbox"
                       disabled={isCurrentStage}
                       checked={rootStore.filters[stage] || isCurrentStage}
                       onChange={this.handleFilterOnChange}
                />
                &nbsp;
                {this.props.intl.formatMessage({id: stage})}
            </label>
        )
    };

    @action
    handleFilterOnChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.props.rootStore.updateFilters(name, value);
        //this.props.rootStore.filters[name] = value;
    };

}

export default injectIntl(Filters);